import { render, staticRenderFns } from "./documentx-ios.vue?vue&type=template&id=1f17ae7e&"
import script from "./documentx-ios.vue?vue&type=script&lang=js&"
export * from "./documentx-ios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports